import { Component, HostBinding, Input } from '@angular/core';

export type DsProgressRingTone = 'neutral' | 'brand' | 'success' | 'info';

@Component({
  selector: 'app-ds-progress-ring',
  templateUrl: './ds-progress-ring.component.html',
  styleUrls: ['./ds-progress-ring.component.scss']
})
export class DsProgressRingComponent {
  @Input() value: number = 0;
  @Input() tone: DsProgressRingTone = 'neutral';

  readonly radius = 40;
  readonly circumference = 2 * Math.PI * 40;

  @HostBinding('attr.data-tone')
  get toneAttr(): DsProgressRingTone { return this.tone; }

  get clampedValue(): number {
    if (!this.value || this.value < 0) {
      return 0;
    }
    if (this.value > 100) {
      return 100;
    }
    return this.value;
  }

  get dashOffset(): number {
    return this.circumference * (1 - this.clampedValue / 100);
  }
}
